module.exports = __webpack_public_path__ + "static/media/home_selected.91533903.svg";